<template>
    
    <div class="content">
        <div class="introduce d_f jc_sb">
            <img :src="texts.picList[0].url" alt="">
            <span>- 公司简介 -</span>
            <div class="text">
                <h2>{{texts.name}}</h2>
                <p>
                    {{texts.profile}}
                </p>
            </div>
        </div>

        <div class="distance">
            <div class="wrap">
                <h2>
                    <a-divider>发展历程</a-divider>
                </h2>

                <div class="time">
                    <a-timeline>
                        <a-timeline-item>
                            <div class="item">
                                <h6>2019年 </h6>
                                <span>———</span>
                                <p>交通灯产品出口销售至全球100多个国家，通过新国标GB14887-2011。广告人行灯取得多项国家专利，并在全国各地得到广泛应用。</p>
                            </div>
                        </a-timeline-item>
                        <a-timeline-item>
                            <div class="item">
                                <h6>2017年 </h6>
                                <span>———</span>
                                <p>巨通交通全面贯彻执行ISO9001-2008质量管理体系。交通灯产品出口全球超90多个国家。产品通过GB14887-2003标准，年销售额超2000万元</p>
                            </div>
                        </a-timeline-item>
                        <a-timeline-item>
                            <div class="item">
                                <h6>2016年 </h6>
                                <span>———</span>
                                <p>迁址在石岩，5000平方米生产面积，企业员工100人。注册资金500万元，年销售额四千多万元。</p>
                            </div>
                        </a-timeline-item>
                        <a-timeline-item>
                            <div class="item">
                                <h6>2014年 </h6>
                                <span>———</span>
                                <p>公司成立，注册资金10万元，公司面积350余平方米。</p>
                            </div>
                        </a-timeline-item>
                    </a-timeline>
                </div>

            </div>
        </div>

        <div class="call">
            <h2>- 联系我们 -</h2>
            <Map />
            <p><img src="../../assets/call.png" alt=""> 公司电话：{{texts.telephoto}}</p>
            <p><img src="../../assets/dw.png" alt="">公司地址：{{texts.address}}</p>
        </div>

    </div>

</template>


<script>
import index from './index'
import Map from '../../components/Map/map'
export default {
    ...index,
    components : {
        Map
    }
}
</script>

<style lang="scss" scoped>
    .wrap{
        width: 1200px;
        margin: auto;
    }
    .introduce{
        width: 1200px;
        margin: 100px auto 50px;
        span{
            display: none;
        }
        img{
            width: 515px;
            height: 345px;
        }
        .text{
            color: #28314a;
            width: 620px;
            h2{
                font-size: 36px;
                margin-bottom: 50px;
            }
            p{
                font-size: 24px;
                line-height: 43px;
            }
        }
    }
    .distance{
        background-color: #f8f8f8;
        padding: 65px 0;

        h2{
            padding: 50px 500px;
        }
        .time{
            padding: 0 100px;
            .item{
                display: flex;
                color: #232b40;
                h6{
                    padding: 0 20px;
                    width: 100px;
                }
                span{
                    width: 70px;
                    color: #ccc;
                }
            }
        }
    }

    .call{
        display: none;
        padding: 100px 0;
        width: 1200px;
        margin: auto;
        text-align: center;
        color: #232b40;
        >img{
            display: none;
        }
        p{
            img{
                display: none;
            }
        }
    }

    @media screen and (max-width: 750px){
        .wrap{
            width: 100%;
        }
        .introduce{
            width: 100%;
            margin: 0;
            padding:5.319vw;
            background:url('../../assets/stained.png') no-repeat center;
            background-size: 100% 100%;
            flex-direction: column;
            img{
                display: none;
            }
            >span{
                display: block;
                width: 100%;
                text-align: center;
                color: #fff;
                padding: 7.979vw 0 2.66vw;
                font-size: 4.521vw;
            }
            .text{
                width: 100%;
                background-color: rgba(255, 255, 255, .5);
                padding:5.319vw;
                h2{
                    font-size: 3.989vw;
                    text-align: center;
                    margin-bottom: 5.319vw;
                }
                p{
                    font-size: 3.458vw;
                    line-height: 5.319vw;
                    color: #28314a;
                    font-family: "PingFangSC-Light";
                }
            }
        }

        .distance{
            padding: 0;
            background-color: #fff;
            h2{
                padding: 0;
                width: 26.596vw;
                margin: 7.979vw auto;
            }
            .time{
                padding: 0 5.319vw;
                .item{
                    h6{
                        width: 22.436vw;
                        font-size: 3.458vw;
                    }
                    span{
                        display: none;
                    }
                    p{
                        flex:1;
                    }
                }
            }
        }


        .call{
            display: block !important;
            width: 100%;
            background-color: #f8f8f8;
            padding: 5.319vw 5.319vw 10.638vw;
            img{
                display: block;
                width: 100%;
                margin: 7.979vw 0;
            }
            h2{
                font-size: 4.521vw;
            }
            p{
                font-size: 3.458vw;
                text-align:left;
                display: flex;
                img{
                    width: 4.521vw;
                    height: 4.521vw;
                    margin: 0;
                    display: block;
                    margin-right: 1.33vw;
                }
            }
        }
    }
</style>